export const TYPES = {
    ICONS: "icons",
    PHOTOS: "photos"
};
